// src/components/CustomIndex/CustomIndex.js

import React from "react";
import { Link } from "react-router-dom";
import "./CustomIndex.css";

export default function CustomIndex() {
  return (
    <div className="custom-index-page">
      {/* Custom header */}
      <header className="custom-header">
        <div className="logo-container">
          {/* <img
            src="../assets/images/ijrr/logo-light.png"
            alt="Jolly Roger Registry"
            className="jolly-roger-logo"
          /> */}
        </div>
      </header>

      {/* Parallax section */}
      <section
        className="custom-parallax"
        style={{ backgroundImage: "url(../assets/images/ijrr/index-bg.jpg)" }}
      >
        <div className="parallax-content">
          <img
            src="../assets/images/ijrr/IJRR-welcome.png"
            alt="Welcome Logo"
            className="welcome-logo"
          />
          <hr className="divider" />
          <div className="steps-container">
            <p className="golden">
              <strong className="highlight-red">3</strong> SIMPLE STEPS TO GETTING YOUR MEMBERSHIP
              <br />
              <strong className="highlight-red">3</strong> STEPS TO CREATE YOUR OWN BRAND
              <br />
              <br />
              <strong className="golden">
                It's so easy even "Lucky" the Parrot can do it!
              </strong>
            </p>
            <Link to="/home">
              <img
                src="../assets/images/ijrr/lucky.png"
                alt="Lucky the Parrot"
                className="lucky-parrot"
              />
            </Link>
            <p>
              <strong className="golden">Step 1:</strong>{" "}
              <Link to="/home" className="white">
                Enter site
              </Link>
            </p>
            <p>
              <strong className="golden">Step 2:</strong> Enter your name and information.
            </p>
            <p>
              <strong className="golden">Step 3:</strong> Download your image and start creating your own personal brand.
            </p>

            {/* Call to Action Button */}
            <div className="custom-mt-40">
              <Link to="/login" className="ijrr-button">
                Member login
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Custom footer */}
      <footer className="cdx-footer minimal-footer">
        <div className="footer-content">
          <img
            src="../assets/images/ijrr/logo-light.png"
            alt="My Jolly Roger"
            className="footer-logo"
          />
          <p>
            © 2026 .{" "}
            <a href="/privacy-policy">Privacy Policy</a>{" "}
            <span className="footer-divider">|</span>{" "}
            <a href="/contact">Contact Us</a>
          </p>
        </div>
      </footer>
    </div>
  );
}